import * as bg1 from '../components/Experience/bg1.json'
import * as bg2 from '../components/Experience/bg2.json'
import * as bg3 from '../components/Experience/bg3.json'
import * as bg1Mo from '../components/Experience/bg1Mo.json'
import * as bg2Mo from '../components/Experience/bg2Mo.json'
import * as bg3Mo from '../components/Experience/bg3Mo.json'

export const experienceData = [
    {
        id: 0,
        background: bg1,
        backgroundMo: bg1Mo,
        title: '기획',
        description: [
            'ICT 서비스의 시작은 브랜드에 대한 기획의 이해입니다.TINS LAB는 고객이 요구하는 사항을 ',
            '정확하게 파악하고 필요한 기능과 서비스 시나리오에 대한 명확한 답변을 제안합니다.'
        ],
        list: [
            '1. 고객 요구사항 수렴',
            '2. 서비스 정책과 방향성 수립',
            '3. 시나리오 플로우 차트 설계',
            '4. 화면 설계를 기반으로 명확한 기능과 화면 뎁스 정의',
            '5. 기획 설계 고객사 검토 및 컨펌',
        ]
    },
    {
        id: 1,
        background: bg2,
        backgroundMo: bg2Mo,
        title: '디자인',
        description: [
            '고객의 브랜드 아이덴티티를 디자인에 녹여냄으로써, 차별화된 사용자 경험을 제공합니다.일관된 색상, 폰트,',
            '이미지 스타일을 적용하여 브랜드의 가치를 디자인 전반에 반영하고, 브랜드 인지도를 높이는데 기여합니다.'
        ],
        list: [
            '1. 서비스 톤 & 매너 정의',
            '2. 디자인 요소 정의(색상, 타이포그래피, 아이콘 등)',
            '3. 기획 기능을 바탕으로 UI 및 UX 프로토 타입 디자인',
            '4. 다양한 기기와 해상도에 맞춘 최적화 디자인 구현',
            '5. 고객 피드백 반영을 통한 디자인 고도화',
        ]
    },
    {
        id: 2,
        background: bg3,
        backgroundMo: bg3Mo,
        title: '개발',
        description: [
            '개발은 TINS LAB의 기술적 역량, 문제 해결 능력, 그리고 고객 요구에 맞춘 최적화된 솔루션을 제공합니다.',
            '고객의 아이디어를 현실로 만들어주는 구체적인 과정과 기술적 전문성을 구현합니다.',
        ],
        list: [
            '1. 데이터베이스 설계 및 관리',
            '2. 개발 환경 구축',
            '3. 프로튼엔드 개발',
            '4. 백엔드 개발',
            '5. 테스트 및 디버깅',
            '6. 배포 및 유지보수',
        ]
    },
]